import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { UserDataModel } from '@modules/auth';

export interface AppState {
  currentUser: UserDataModel;
  twilioToken: string;
}

export const appStateDefault: AppState = {
  currentUser: undefined,
  twilioToken: undefined,
};

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  // TODO move all to ngrx state (Settings)
  private stateSubject$: BehaviorSubject<AppState> = new BehaviorSubject<AppState>({...appStateDefault});

  public state$: Observable<AppState> = this.stateSubject$.asObservable();
  public currentUser$: Observable<UserDataModel> = this.state$.pipe(
    map(({currentUser}) => currentUser),
    filter((currentUser) => Boolean(currentUser?.id))
  );

  public authToken$: Observable<string> = this.state$.pipe(
    map(({currentUser}) => currentUser?.jwToken),
    distinctUntilChanged(),
  );

  public twilioToken$: Observable<string> = this.state$.pipe(
    map(({twilioToken}) => twilioToken),
    filter(it => Boolean(it)),
    distinctUntilChanged(),
  );

  constructor() {
    (window as any).appStateService = this;
  }

  get state() {
    return this.stateSubject$.getValue();
  }

  patchState(payload: Partial<AppState>): AppState {
    this.stateSubject$.next({...this.stateSubject$.getValue(), ...payload});
    return this.stateSubject$.getValue();
  }

  reset() {
    this.stateSubject$.next({...appStateDefault});
  }
}
